var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roles-form',{on:{"submit":_vm.addRole,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }